/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useEffect } from 'react'
import { Input } from '../../components/Input/Input'
import { Animation, ItemsGrid } from '../../styling/GlobalStyles'
import { useDispatch, useSelector } from 'react-redux'
import { HonestSelectInput } from '../../components/HonestSelect/HonestSelectInput'
import { ISelectValue } from 'constants/globalTypes'
import { HonestSelectAsyncInput } from 'components/HonestAsyncSelect/HonestAsyncSelectInput'
import { AppDispatch, RootState } from 'store'
import { clearModel, getSingleMachineModel } from 'features/machineModels/machineModelsSlice'
import useFocusFirstInput from 'utils/useFocusFirstInput'
import { IMachineryTab } from 'types/machinery.interface'
import { IVehicleListSingleResponse } from 'types/api/machineryApi.interface'
import CalendarInput from 'components/CalendarInput/CalendarInput'

export const MachinerySpecificationTab = ({
  state,
  setState,
  isAdding
}: IMachinerySpecificationTab) => {
  const dispatch = useDispatch<AppDispatch>()
  const ownershipList = [
    { label: 'Company', value: 1 },
    { label: 'Rented', value: 2 },
  ]
  const usageTypeOptions = [
    { label: 'Hours worked', value: 1 },
    { label: 'Mileage', value: 2 },
  ]
  const statusOptions = [
    { label: 'Free', value: 1 },
    { label: 'Broken', value: 3 },
    { label: 'In Maintenance', value: 4 },
  ].filter(s => isAdding ? s.label !== 'Free' : true)

  const { singleModel } = useSelector((store: RootState) => store.machineModels)

  useFocusFirstInput()

  useEffect(() => {
    if (singleModel) {
      setState((prev) => ({
        ...prev,
      }))
    }


  }, [state?.machineryModel, singleModel])

  useEffect(() => {
    return () => {
      dispatch(clearModel())
    }
  }, [])

  const handleChange = (e: React.FormEvent<HTMLInputElement>, index: number) => {
    const { name, value, type } = e.target as HTMLInputElement
    setState((prev) => {
      const copy = { ...prev }
      if (name.startsWith('maint')) {
        const newName = name.split('-')
        copy.maintenanceCosts.map((item, i) => {
          if (index === i) {
            item[newName[1]] = value
          }
          return item
        })
        return copy
      } else {
        copy[name] = type == 'number' ? Number(value) : value
      }
      return copy
    })
  }


  const handleSelect = (value: ISelectValue, name: string) => { // todo refactor
    const copy = structuredClone(state)

    switch (name) {
      case 'machineCategory':
        copy.machineCategory = { id: value.value, name: value.label, iconName: null }
        break
      case 'vehicle':
        // @ts-ignore 
        copy.vehicleProvider = Number((value.value as string)?.split('_')[1])
        // @ts-ignore 
        copy.vehicle = { id: copy.vehicleProvider == 3 ? value.value?.split('_')[0] : Number((value.value as string)?.split('_')[0]), name: value.label }
        break
      case 'machineryModel':
        value.value && dispatch(getSingleMachineModel(value.value))
        copy.machineryModel = { id: value.value, name: value.label }
        break
      case 'ownership':
        copy.ownership = value.value
        break
      case 'usageType':
        copy.usageType = value.value
        break
      default:
        copy[name] = value.value
        break
    }

    setState(copy)
  }

  const handleDateChange = (dt: Date, name: string) => {
    setState((prev) => {
      const copy = { ...prev }
      copy[name] = new Date(dt).toDateString()
      return copy
    })
  }

  const parseCategories = (data: any) => {
    return data ? data.data.map((item: any) => ({ label: item.name, value: item.id })) : []
  }

  const parseModels = (data: any) => {
    return data
      ? data.data.map((item: any) => ({
        label: item.machineModel.make + ' ' + item.machineModel.model,
        value: item.machineModel.id,
      }))
      : []
  }

  const parseVehicles = (data: IVehicleListSingleResponse[]) => {
    return data
      ? data.map((item) => {
        const type = item.provider == 2 ? 'almaksVehicle' : item.provider == 3 ? 'develonVehicle' : 'frotcomVehicle'
        let label = item[type][item.provider == 2 ? 'name' : item.provider == 3 ? 'equipmentId' : 'model']
        if (item.provider == 1) {
          label = item[type].manufacturer + ' ' + (item[type].model || ' ') + ' ' + item[type].licensePlate
        }
        return {
          label,
          value: String(item[type].id) + '_' + String(item.provider)
        }
      })
      : []
  }

  return (
    <Animation>
      <ItemsGrid columns={3}>
        <Input
          labelText='Machine Name'
          type='text'
          name='name'
          placeholder='Enter name'
          value={state?.name}
          onChange={handleChange}
          invalid={!state?.name}
          required
        />
        <HonestSelectAsyncInput
          link='machine-categories'
          placeholder='Search categories'
          name='machineCategory'
          labelText='Category'
          defaultValue={state?.machineCategory?.name}
          onChange={(value: ISelectValue) => handleSelect(value, 'machineCategory')}
          parserFunction={parseCategories}
          invalid={!state?.machineCategory?.id}
          required
        />
        <HonestSelectAsyncInput
          link='machine-models'
          placeholder='Search machine models'
          name='machineryModel'
          labelText='Machine model'
          defaultValue={state?.machineryModel?.name}
          onChange={(value: ISelectValue) => handleSelect(value, 'machineryModel')}
          parserFunction={parseModels}
          invalid={!state?.machineryModel?.id}
          required
        />

        <HonestSelectAsyncInput
          link='machines/vehicles/list'
          placeholder='Search vehicles'
          name='vehicleId'
          labelText='Vehicle'
          defaultValue={state?.vehicle ? (state?.vehicle?.name ?? (state?.vehicle?.manufacturer + ' ' + state?.vehicle?.model + ' ' + state?.vehicle?.licensePlate)) : null}
          onChange={(value: ISelectValue) => handleSelect(value, 'vehicle')}
          parserFunction={parseVehicles}
          noPagination
        />

        <HonestSelectInput
          name='status'
          labelText='Status'
          options={statusOptions}
          defaultValue={state?.status}
          onChange={(value: ISelectValue, param: string) => {
            handleSelect(value, param)
          }}
          invalid={!isAdding && !state?.status}
        />

        <HonestSelectInput
          name='ownership'
          labelText='Ownership'
          options={ownershipList}
          defaultValue={state?.ownership}
          onChange={(value: ISelectValue, param: string) => {
            handleSelect(value, param)
          }}
        />
        {state?.ownership &&
          (state?.ownership == 2 ? <>
            <Input
              type='number'
              name='costPerHour'
              labelText='Cost per hour'
              placeholder='Enter cost per hour'
              value={state.costPerHour}
              onChange={handleChange}
              required
              invalid={!state.costPerHour}
            />
            <CalendarInput
              defaultValue={state.rentedUntilDate ? new Date(state?.rentedUntilDate) : null}
              name='rentedUntilDate'
              minDate={new Date()}
              labelText='Rented Until'
              onChange={handleDateChange}
            />

          </> : (
            <>
              <Input
                type='number'
                name='machineCost'
                labelText='Machine cost'
                placeholder='Machine cost'
                value={state?.machineCost}
                onChange={handleChange}
                required
                invalid={!state.machineCost}
              />

              <CalendarInput
                defaultValue={state.purchaseDate ? new Date(state?.purchaseDate) : null}
                name='purchaseDate'
                maxDate={new Date()}
                labelText='Purchase Date'
                onChange={handleDateChange}
              />

            </>
          ))}
        <HonestSelectInput
          name='usageType'
          labelText='Usage Type'
          options={usageTypeOptions}
          defaultValue={state?.usageType}
          onChange={(value: ISelectValue, param: string) => {
            handleSelect(value, param)
          }}

        />
        {state?.usageType &&
          (state?.usageType == 1 ? (
            <Input
              type='number'
              name='hoursWorked'
              labelText='Hours worked'
              placeholder='Enter hours worked'
              value={state?.hoursWorked}
              onChange={handleChange}
            />
          ) : (
            <Input
              type='number'
              name='mileage'
              labelText='Mileage'
              placeholder='Enter mileage'
              value={state?.mileage}
              onChange={handleChange}
            />
          ))}
        <Input
          name='chassisNumber'
          value={state?.chassisNumber}
          labelText='Chassis Number'
          placeholder='Enter chassis number'
          onChange={handleChange}
        />

        <Input
          name='licensePlate'
          value={state?.licensePlate}
          labelText='License Plate'
          placeholder='Enter license plate'
          onChange={handleChange}
        />

        <Input
          type='number'
          name='yearOfManfacture'
          labelText='Year Of Manufacture'
          placeholder='1997'
          value={state?.yearOfManfacture}
          onChange={handleChange}
        />

        <Input
          name='fuelTankCapacity'
          type='number'
          value={state?.fuelTankCapacity}
          labelText='Fuel Tank Capacity'
          placeholder='Enter tank capacity'
          onChange={handleChange}
        />
        {/* <Flex column>
          <Flex gap='0.5rem'>
            {state?.maintenanceCosts?.map((item, index) => {
              return (
                <div key={index}>
                  <Input
                    name='maint-year'
                    labelText='Estimated Maintenance Cost per year'
                    placeholder='Enter maintenance cost'
                    type='number'
                    value={item.year}
                    invalid={invalidFields.includes('maint-year') ? 'true' : ''}
                    onChange={(e) => handleChange(e, index)}
                  />
                  <Flex gap='1rem'>
                    <Input
                      name='maint-q1'
                      onChange={(e) => handleChange(e, index)}
                      placeholder='q1'
                      type='number'
                      w='25%'
                      invalid={invalidFields.includes('maint-q1') ? 'true' : ''}
                      value={item.q1}
                      noinvalidtext='true'
                    />
                    <Input
                      value={item.q2}
                      name='maint-q2'
                      placeholder='q2'
                      onChange={(e) => handleChange(e, index)}
                      type='number'
                      w='25%'
                      invalid={invalidFields.includes('maint-q2') ? 'true' : ''}
                      noinvalidtext='true'
                    />
                    <Input
                      value={item.q3}
                      name='maint-q3'
                      placeholder='q3'
                      onChange={(e) => handleChange(e, index)}
                      type='number'
                      invalid={invalidFields.includes('maint-q3') ? 'true' : ''}
                      w='25%'
                      noinvalidtext='true'
                    />
                    <Input
                      value={item.q4}
                      name='maint-q4'
                      placeholder='q4'
                      invalid={invalidFields.includes('maint-q4') ? 'true' : ''}
                      onChange={(e) => handleChange(e, index)}
                      noinvalidtext='true'
                      type='number'
                      w='25%'
                    />
                  </Flex>
                </div>
              )
            })}
          </Flex>
        </Flex> */}
      </ItemsGrid>
    </Animation>
  )
}


interface IMachinerySpecificationTab extends IMachineryTab {
  isAdding?: boolean
}
